import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }

    try {
      // @ts-ignore - getRequest is available in server environments
      const { getRequest } = await import("@tanstack/react-start/server");
      const request = getRequest();
      if (
        request &&
        (!request.headers.get("accept")?.includes("text/html") ||
          new URL(request.url).searchParams.has("_serverFnId"))
      ) {
        throw error;
      }
    } catch (e) {
      // Ignored
    }

    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  requestMiddleware: [errorMiddleware],
  functionMiddleware: [attachSupabaseAuth],
}));
